import Helpers from "../helpers/helperFunctions";
import {
    OPEN_POPUP, CLOSE_POPUP, UI_OPEN, UI_CLOSE, UI_LAST_ROUTE_TYPE, UI_CURRENT_ROUTE_TYPE, UI_PREVIOUS_PATH,
    CONFIRMATION_DIALOG_ANSWER, UI_LOADING, UI_LOADING_DONE,
    UI_LOADING_RESET, UI_LOADING_FAILED, SCROLLED_TO_SPORT_ALIAS, SCROLL_TO_SPORT_ALIAS, TOGGLE_VIRTUAL_KEYBOARD,
    SAVE_POPUP_TIMER, TOGGLE_POPUP_TIMER, CHECK_CASHOUT_TICKET, DATA_FINISHED, CHECKED_TICKETS, CLOSE_GAME_COMPONENT, EARLY_CASHOUT, SPORT_GAMES_COUNT, UI_TOGGLE_ONE_GAME_ALL_MARKETS, TOGGLE_REGION_CLASS, MOVE_GAME_STEP, VIRTUALS_VIDEO_STREAM, TICKET_SCAN,
    CHANGE_ODDS_FORMAT,
    OPEN_IDLE_POPUP,
    CLOSE_IDLE_POPUP
} from "../actions/actionTypes/";
import Config from "../config/main";

const maxLengthHistory = 100;

const UIStateReducer = (
    state = {
        opened: {},
        loading: {},
        failReason: {},
        confirmation: {},
        lastRouteType: "",
        previousPath: "",
        sportGamesCount: '',
        currentRouteType: "",
        callbackList: {},
        selectedSportAlias: "",
        multiComponent: {
            bool: false,
            array: [],
            cursor: 0
        },
        toggleRegionid: {
            cursor: null
        },
        virtualsParams: {},
        tickets: {},
        isFinished: false,
        checkedTickets: null,
        cashoutTicket: null,
        oddsFormat: Config.env.oddsFormat,
        earlyCashout: null,
        timer: null,
        showTimer: false
    },
    action = {}
) => {
    let ret = Helpers.cloneDeep(state);

    switch (action.type) {
        case UI_OPEN:
            ret.opened[action.key] = true;
            action.key === "registrationForm" && (ret.opened.rightMenu = true);
            action.key === "rightMenu" && (ret.opened.registrationForm = false);
            return ret;
        case UI_CLOSE:
            action.key === "betslip" && (ret.showVirtualKeyBoard = false);
            ret.opened[action.key] = false;
            return ret;
        case UI_LOADING:
            ret.loading[action.key] = true;
            return ret;
        case EARLY_CASHOUT:
            if (action.bool) {
                ret.earlyCashout = { ...ret.earlyCashout, ...action.payload };
            } else {
                ret.earlyCashout = null;
            }
            return ret;
        case SAVE_POPUP_TIMER:
            ret.timer = action.payload;
            return ret;
        case TOGGLE_POPUP_TIMER:
            ret.showTimer = action.payload;
            return ret;
        case TICKET_SCAN:
            if (action.bool) {
                if (ret.tickets[action.barcode]) delete ret.tickets[action.barcode];
                ret.tickets = { ...ret.tickets, ...action.payload };
            } else if (action.payload && !action.bool) {
                const newState = ret.tickets;
                delete newState[action.payload];
                ret.tickets = { ...newState };
            } else {
                ret.tickets = {};
            }
            return ret;
        case DATA_FINISHED:
            ret.isFinished = action.payload;
            return ret;
        case CHANGE_ODDS_FORMAT:
            ret.oddsFormat = action.payload;
            return ret;
        case CHECK_CASHOUT_TICKET:
            ret.cashoutTicket = action.payload;
            return ret;
        case CHECKED_TICKETS:
            ret.checkedTickets = action.payload;
            return ret;
        case UI_LOADING_DONE:
            ret.loading[action.key] = false;
            ret.failReason[action.key] = undefined;
            return ret;
        case UI_LOADING_FAILED:
            ret.loading[action.key] = false;
            ret.failReason[action.key] = action.reason;
            return ret;
        case UI_LOADING_RESET:
            delete ret.loading[action.key];
            delete ret.failReason[action.key];
            return ret;
        case SPORT_GAMES_COUNT:
            ret.sportGamesCount = action.payload;
            return ret;
        case CLOSE_POPUP:
            ret.popup = null;
            ret.popupParams = null;
            return ret;
        case OPEN_POPUP:
            ret.popup = action.key;
            ret.popupParams = action.payload;
            return ret;
        case CLOSE_IDLE_POPUP:
            ret.idlePopupOpen = false;
            return ret;
        case OPEN_IDLE_POPUP:
            ret.idlePopupOpen = true;
            return ret;
        case UI_LAST_ROUTE_TYPE:
            ret.lastRouteType = action.routeType;
            return ret;
        case TOGGLE_REGION_CLASS:
            ret.toggleRegionid.bool = action.payload.bool;
            ret.toggleRegionid.cursor = action.payload.regionId;
            return ret;
        case UI_PREVIOUS_PATH:
            ret.previousPath = action.path;
            return ret;
        case UI_CURRENT_ROUTE_TYPE:
            ret.currentRouteType = action.routeType;
            return ret;
        case CONFIRMATION_DIALOG_ANSWER:
            ret.confirmation[action.key] = { answer: action.answer, data: action.payload };
            return ret;
        case VIRTUALS_VIDEO_STREAM:
            ret.virtualsParams = action.payload;
            return ret;
        case SCROLL_TO_SPORT_ALIAS:
            ret.selectedSportAlias = action.payload;
            return ret;
        case TOGGLE_VIRTUAL_KEYBOARD:
            ret.showVirtualKeyBoard = action.payload;
            return ret;
        case SCROLLED_TO_SPORT_ALIAS:
            delete ret.selectedSportAlias;
            return ret;
        case UI_TOGGLE_ONE_GAME_ALL_MARKETS:
            ret.multiComponent.bool = action.payload.bool;
            if (action.payload.bool) {
                const ifExsist = ret.multiComponent.array.findIndex((item) => item === action.payload.gameId);
                if (ifExsist < 0) {
                    if (ret.multiComponent.array.length === maxLengthHistory) {
                        ret.multiComponent.array.shift();
                        ret.multiComponent.cursor = ret.multiComponent.array.push(action.payload.gameId) - 1;
                    } else {
                        ret.multiComponent.cursor = ret.multiComponent.array.push(action.payload.gameId) - 1;
                    }
                } else {
                    ret.multiComponent.cursor = ifExsist;
                }
            }
            return ret;
        case MOVE_GAME_STEP:
            if (((ret.multiComponent.cursor + action.payload) < ret.multiComponent.array.length) && ((ret.multiComponent.cursor + action.payload) >= 0)) {
                ret.multiComponent.cursor += action.payload;
            }
            return ret;
        case CLOSE_GAME_COMPONENT:
            ret.multiComponent.bool = false;
            return ret;
        default:
            return state;
    }
};

export default UIStateReducer;